<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    :title="title"
  >
    <template v-slot:header="{ ok, cancel }">
      <v-card-title class="screen-title">{{ title }}</v-card-title>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="isChanged ? ok() : cancel()"
      >
        ×
      </button>
    </template>
    <template v-if="isLoaded" v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showVNConnectModify"
                  >変更</v-btn
                >
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showVNConnectDelete"
                  >削除</v-btn
                >
              </v-col>
            </v-row>
            <v-alert v-if="alertMsg" class="my-2" :text="alertMsg"></v-alert>
            <v-row>
              <!-- 基本設定 -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>基本設定</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="サービスキー(Act)"
                        :value="cloudDetail.serviceKey"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="サービスキー(Sby)"
                        :value="cloudDetail.serviceKey"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="回線番号"
                        :value="cloudDetail.enumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="品目"
                        :value="
                          cloudDetail.cloudVnConnectCommon.bandwidthType +
                          '(' +
                          $filter.bandwidthTo(
                            cloudDetail.cloudVnConnectCommon.bandwidth
                          ) +
                          ')'
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ロケーション"
                        :value="
                          $filter.enumTo(cloudDetail.location, 'location')
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="備考"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectCommon.description,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!-- 接続先VPN/VN -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>接続先VPN/VN</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VPN/VNコード"
                        :value="cloudDetail.cloudVnConnectCommon.vpnVnCode"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="仮想ネットワーク(VN)名"
                        :value="
                          cloudDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                            'B'
                          )
                            ? '-'
                            : cloudDetail.cloudVnConnectCommon.vnName
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="L2/L3"
                        :value="cloudDetail.cloudVnConnectCommon.vnType"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ルーティング種別"
                        :value="cloudDetail.cloudVnConnectCommon.routingType"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="AS番号"
                        :value="cloudDetail.cloudVnConnectAct.asNumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MD5キー"
                        :value="cloudDetail.cloudVnConnectAct.md5Key"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Maximum Prefix"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectAct.maximumPrefix,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <!-- 回線情報（Act） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>回線情報(Act)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト番号"
                        :value="cloudDetail.cloudVnConnectAct.wnumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="cloudDetail.cloudVnConnectAct.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="有効/無効"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!-- 回線情報（Sby） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>回線情報(Sby)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト番号"
                        :value="cloudDetail.cloudVnConnectSby.wnumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="cloudDetail.cloudVnConnectSby.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="有効/無効"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <!-- ルーティング情報（Act） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectAct.wanAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectAct.peerIpAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!-- ルーティング情報（Sby） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectSby.wanAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectSby.peerIpAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row
              class="mt-2"
              v-if="
                cloudDetail.cloudVnConnectCommon.cloudServiceType ===
                'PRIVATE_PEERING'
              "
            >
              <!-- カスタム経路集約情報 -->
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="経路集約"
                        :value="
                          cloudDetail.cloudVnConnectCommon.routeAggregation
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      cloudDetail.cloudVnConnectCommon.routeAggregation !==
                      'OFF'
                    "
                  >
                    <v-col>
                      <app-label-group label="経路集約アドレス">
                        <template #value>
                          <template
                            v-if="
                              cloudDetail.cloudVnConnectCommon
                                .routeAggregation === 'CUSTOM'
                            "
                          >
                            <div class="d-flex flex-wrap">
                              <span
                                class="ml-3"
                                v-for="(ip, index) in cloudDetail
                                  .cloudVnConnectCommon
                                  .routeAggregationAddressList"
                                :key="index"
                              >
                                {{ ip }}
                              </span>
                            </div>
                          </template>
                          <template
                            v-else-if="
                              cloudDetail.cloudVnConnectCommon
                                .routeAggregation === 'ON'
                            "
                          >
                            <span class="ml-3">0.0.0.0/0</span>
                          </template>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  @update:modelValue="alertClear"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tab text="運用コマンド(Act)" value="operationCommandAct" />
                  <!--運用コマンド(Sby)-->
                  <v-tab text="運用コマンド(Sby)" value="operationCommandSby" />
                  <!--トラフィック-->
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="!isFutureDayContract && contractSummary.isTrafficInfo"
                  />
                  <!--設定上限値-->
                  <v-tab text="設定上限値" value="upperLimit" />
                  <!-- QoS設定情報 -->
                  <v-tab
                    text="QoS設定情報"
                    value="qos"
                    v-if="
                      cloudDetail.cloudVnConnectCommon.cloudServiceType ===
                      'MICROSOFT_PEERING'
                    "
                  />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tabs-window-item value="operationCommandAct">
                    <operation-command
                      ref="operationCommandAct"
                      lineCategory="CLOUD"
                      :wnumber="cloudDetail.cloudVnConnectAct.wnumber"
                      :showIfStatus="false"
                      :ifStatus="cloudDetail.cloudVnConnectAct.ifStatus"
                      :key-id="cloudDetail.cloudVnMsKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--運用コマンド(Sby)-->
                  <v-tabs-window-item value="operationCommandSby">
                    <operation-command
                      ref="operationCommandSby"
                      lineCategory="CLOUD"
                      :wnumber="cloudDetail!.cloudVnConnectSby!.wnumber"
                      :showIfStatus="false"
                      :ifStatus="cloudDetail!.cloudVnConnectSby!.ifStatus"
                      :key-id="cloudDetail.cloudVnMsKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--トラフィック-->
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="MULTICLOUD"
                      :line="{
                        wnumberMainAct: cloudDetail.cloudVnConnectAct.wnumber,
                        wnumberMainSby: cloudDetail.cloudVnConnectSby.wnumber,
                      }"
                    />
                  </v-tabs-window-item>

                  <!--設定上限値-->
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit
                      upperLimitManageUnit="MULTI_CLOUD"
                      :wnumber="cloudDetail.cloudVnConnectAct.wnumber"
                      :cloud-line-seq="cloudLineSeq"
                    />
                  </v-tabs-window-item>
                  <!-- QoS設定情報 -->
                  <v-tabs-window-item value="qos">
                    <cloud-qos-setting
                      :vpnVnCode="cloudDetail.cloudVnConnectCommon.vpnVnCode"
                      :band-control-pattern="
                        cloudDetail.cloudVnConnectCommon!.qos!
                          .qosBandControlPattern
                      "
                    ></cloud-qos-setting>
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="isChanged ? ok() : cancel()"
              variant="outlined"
              color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { mapState } from "vuex";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { CloudVnMsDetail, CloudVnMsList } from "@/apis/CloudVnMsApi";
import MultiCloudVNConnectionConfirmMS from "@/modals/multicloud/ms/MultiCloudMsVnConnectionConfirm.vue";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import CloudQosSetting from "@/components/operation-tool/CloudQosSetting.vue";
import MultiCloudMsVnLineEdit from "@/modals/multicloud/ms/MultiCloudMsVnLineEdit.vue";

import type { ContractInfo } from "@/apis/ContractApi";

export default defineComponent({
  name: "MultiCloudMsVnConnectionReference",
  components: { OperationCommand, Traffic, UpperLimit, CloudQosSetting },
  props: {
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      cloudList: {} as CloudVnMsList,
      cloudDetail: {} as CloudVnMsDetail,
      isLoaded: false,
      alertMsg: null as string | null,
      isChanged: false,
      tabValue: "operationCommandAct" as
        | "operationCommandSby"
        | "traffic"
        | "upperLimit"
        | "qos",
    };
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),
    /** 開始日が未来日の場合,true*/
    isFutureDayContract(): boolean {
      return !this.contractInfo.contractList.find(
        (e: ContractInfo["contractList"][0]) =>
          e.enumber === this.cloudDetail.enumber
      );
    },
    title(): string {
      if (!this.isLoaded) {
        return "";
      }
      if (
        this.cloudDetail.cloudVnConnectCommon.cloudServiceType ===
        "PRIVATE_PEERING"
      ) {
        return "Microsoft Azure(Private Peering)向けVNコネクト情報";
      } else {
        return "Microsoft Azure(Microsoft Peering)向けVNコネクト情報";
      }
    },
  },

  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      this.cloudList = await this.$api.cloudVnMs.getVnConnects(
        this.cloudLineSeq
      );
      this.cloudDetail = await this.$api.cloudVnMs.getVnConnect(this.wnumber);
      // 経路集約アドレスを数値昇順でソート
      if (
        this.cloudDetail.cloudVnConnectCommon &&
        Array.isArray(
          this.cloudDetail.cloudVnConnectCommon.routeAggregationAddressList
        )
      ) {
        this.cloudDetail.cloudVnConnectCommon.routeAggregationAddressList =
          this.cloudDetail.cloudVnConnectCommon.routeAggregationAddressList.sortIpAddress();
      }
    },
    async showVNConnectDelete() {
      await this.alertClear();
      if (
        this.cloudList.cloudVnConnectsList.length >= 2 &&
        this.cloudDetail.cloudVnConnectCommon.cloudServiceType ===
          "PRIVATE_PEERING"
      ) {
        this.alertMsg = "Microsoft Peering向けVNコネクトから削除してください。";
        return;
      } else {
        this.alertMsg = null;
      }

      // 削除確認モーダルの表示
      await this.$modal.show(MultiCloudVNConnectionConfirmMS, {
        cloudVnMsDetail: this.cloudDetail,
        displayType: "D",
      });
      // 削除処理
      await this.$api.cloudVnMs.deleteVnConnect(this.cloudLineSeq, {
        cloudVnConnectList: [
          this.cloudDetail.cloudVnConnectAct.wnumber,
          this.cloudDetail.cloudVnConnectSby.wnumber,
        ],
        cloudVnMsKeyId: this.cloudList.cloudVnMsKeyId,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    async showVNConnectModify() {
      await this.alertClear();
      this.alertMsg = null;
      // 変更ダイアログを表示
      await this.$modal.show(MultiCloudMsVnLineEdit, {
        cloudVnMsDetail: this.cloudDetail,
        cloudLineSeq: this.cloudLineSeq,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    async executed() {
      this.isChanged = true;
      await this.load();
    },

    /** エラーメッセージを初期化する */
    async alertClear() {
      (
        this.$refs.operationCommandAct as InstanceType<typeof OperationCommand>
      ).alertClear();
      if (this.$refs.operationCommandSby) {
        (
          this.$refs.operationCommandSby as InstanceType<
            typeof OperationCommand
          >
        ).alertClear();
      }
    },
  },
});
</script>
